import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryCards from './components/CategoryCards';
import HotComments from './components/HotComments';
import SubscribeCTA from './components/SubscribeCTA';
import { faqData } from '@/mocks/articles';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '黑料718',
        url: 'http://gjxfl.cn/',
        description: '国内领先的娱乐资讯聚合平台，主打网红塌房、明星聊天记录泄露和博主反差视频等爆料内容',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'hello@gjxfl.cn',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '黑料718',
        url: 'http://gjxfl.cn/',
        description: '黑料718品牌聚合页，整合黑料718官网、入口、APP下载及最新地址等核心访问方式',
        potentialAction: {
          '@type': 'SearchAction',
          'target': 'http://gjxfl.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '黑料718 - 首页',
        url: 'http://gjxfl.cn/',
        description: '黑料718品牌聚合页，整合黑料718官网、入口、APP下载及最新地址。实时吃瓜黑料追踪站，主打网红塌房、明星聊天记录泄露和博主反差视频等爆料内容。',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://gjxfl.cn/' },
          ],
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqData.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <title>黑料718 | 黑料718官网入口与黑料718下载 | 实时吃瓜黑料追踪站</title>
      <meta name="description" content="黑料718品牌聚合页，整合黑料718官网、入口、APP下载及最新地址等核心访问方式。主打网红塌房、明星聊天记录泄露和博主反差视频等爆料内容，承接用户对718黑料及黑料正能量718的浏览需求。" />
      <meta name="keywords" content="黑料718, 黑料718官网, 黑料718入口, 黑料718下载, 黑料718最新地址, 718黑料, 黑料正能量718, 网红塌房, 吃瓜爆料, 实时黑料" />
      <link rel="canonical" href="http://gjxfl.cn/" />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
            <FeaturedGrid />
          </article>
          <CategoryCards />
          <HotComments />
          <SubscribeCTA />
        </main>
        <Footer />
      </div>

      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </>
  );
}